import Vue from 'vue';
import VueRouter from 'vue-router';

import authRoutes from './authRoutes';
import customerRoutes from './customerRoutes';
import adminRoutes from './adminRoutes';

Vue.use(VueRouter);

const routes = [
  ...authRoutes,
  ...customerRoutes,
  ...adminRoutes,
  {
    path: '*',
    component: () => import(/* webpackChunckName: "404" */ '../pages/404'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  linkActiveClass: 'active-route',
  routes,
  scrollBehavior(_, __, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

export default router;
